/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

import type { WorkGeoLocationPointDTO } from './WorkGeoLocationPointDTO';
import {
    WorkGeoLocationPointDTOFromJSON,
    WorkGeoLocationPointDTOFromJSONTyped,
    WorkGeoLocationPointDTOToJSON,
    WorkGeoLocationPointDTOToJSONTyped,
} from './WorkGeoLocationPointDTO';

/**
 * 
 * @export
 * @interface WorkGeoLocationPolygonDTO
 */
export interface WorkGeoLocationPolygonDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkGeoLocationPolygonDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationPolygonDTO
     */
    inLatitude?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkGeoLocationPolygonDTO
     */
    inLongitude?: string;
    /**
     * 
     * @type {Array<WorkGeoLocationPointDTO>}
     * @memberof WorkGeoLocationPolygonDTO
     */
    workGeoLocationPoints?: Array<WorkGeoLocationPointDTO>;
}

/**
 * Check if a given object implements the WorkGeoLocationPolygonDTO interface.
 */
export function instanceOfWorkGeoLocationPolygonDTO(value: object): value is WorkGeoLocationPolygonDTO {
    return true;
}

export function WorkGeoLocationPolygonDTOFromJSON(json: any): WorkGeoLocationPolygonDTO {
    return WorkGeoLocationPolygonDTOFromJSONTyped(json, false);
}

export function WorkGeoLocationPolygonDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkGeoLocationPolygonDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'inLatitude': json['inLatitude'] == null ? undefined : json['inLatitude'],
                  'inLongitude': json['inLongitude'] == null ? undefined : json['inLongitude'],
              'workGeoLocationPoints': json['workGeoLocationPoints'] == null ? undefined : ((json['workGeoLocationPoints'] as Array<any>).map(WorkGeoLocationPointDTOFromJSON)),
    };
}

export function WorkGeoLocationPolygonDTOToJSON(json: any): WorkGeoLocationPolygonDTO {
    return WorkGeoLocationPolygonDTOToJSONTyped(json, false);
}

export function WorkGeoLocationPolygonDTOToJSONTyped(value?: WorkGeoLocationPolygonDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'inLatitude': value['inLatitude'],
        'inLongitude': value['inLongitude'],
        'workGeoLocationPoints': value['workGeoLocationPoints'] == null? value['workGeoLocationPoints']: (value['workGeoLocationPoints'] as Array<any>).map(WorkGeoLocationPointDTOToJSON),
    };
}


